<template>
  <a-modal
    centered
    :visible="visible"
    :width="508"
    :body-style="{ minHeight: 'min(600px, 65vh)' }"
    :height="680"
    @cancel="handleClose"
    title="Gestionar secuencias"
  >
    <section class="steps">
      <a-tabs v-model:activeKey="current">
        <a-tab-pane :key="0" :tab="steps[0]">
          <CustomScrollbar height="500px" class="step_body">
            <StepConfigureSequences
              :visible="props.visible"
              :record="props.record"
              @changeSequence="handleUpdateSequence"
            ></StepConfigureSequences>
          </CustomScrollbar>
        </a-tab-pane>
        <a-tab-pane :key="1" :tab="steps[1]">
          <CustomScrollbar height="500px" class="step_body" ref="scrollHistory">
            <div class="loading-container"  v-if="loading" >
              <LoadingOutlined  />
            </div>
            <StepSequenceHistory v-else :record="props.record" :historySequence="historySequence" />
          </CustomScrollbar>
        </a-tab-pane>
      </a-tabs>
    </section>
    <template v-slot:footer>
      <a-button @click="handleClose"> Cancelar </a-button>
      <a-button
        key="submit"
        type="primary"
        id="create-portfolio"
        @click="handleOk"
        :disabled="isDisabled"
      >
        Guardar
      </a-button>
    </template>
  </a-modal>
</template>
<script setup lang="ts">
import StepConfigureSequences from "@/app/contacts/components/steps/StepConfigureSequences.vue";
import StepSequenceHistory from "@/app/contacts/components/steps/StepSequenceHistory.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { updateSequenceContact } from "@/app/contacts/services";
import { fetchRecordsSequence } from "@/app/contacts/services";
import { ref, watch, computed } from "vue";
import { message } from "ant-design-vue";
import { useStore } from "vuex";

const props = withDefaults(
  defineProps<{
    visible: boolean;
    record: {
      id: number;
      fullName: string;
      entity_name: string;
      portfolio_name: string;
      portfolio: number;
    } | null;
  }>(),
  {
    visible: false,
    record: null,
  }
);

const scrollHistory = ref();
const store = useStore();

const sequenceId = ref<number | null>(null);
// const firstsequenceId = ref<number | null>(null);
const historySequence = ref<any>([]);
const steps = ["Configurar Secuencia", "Historial de secuencia"];
const current = ref(0);
const emit = defineEmits(["close"]);
const handleClose = () => {
  // firstsequenceId.value = null;
  emit("close");
};

const loading = ref(false);
const handleOk = async () => {
  try {
    if (props?.record?.id) {
      await updateSequenceContact(props.record.id, sequenceId.value);
      message.success(sequenceId.value ? "El contacto fue añadido a la secuencia correctamente" : "El contacto fue eliminado de la secuencia correctamente.");
      handleClose();
    }
  } catch (error) {
    const errorMessage = error?.getErrorMessage() || "Ha courrido un error";

    message.error(errorMessage);
  }
};

const firstSequenceId = computed(() => store.getters["getContact"]?.sequence_data?.id || '');

const isDisabled = computed(() => {
  return firstSequenceId.value == sequenceId.value;
});

const handleUpdateSequence = async (sequenceIdNew: number) => {
  sequenceId.value = sequenceIdNew;
};

watch(
  () => props.visible,
  async (value) => {
    if (props.record?.id && value) {
      loading.value = true;
      const response = await fetchRecordsSequence(props.record.id);
      historySequence.value = response;
      loading.value = false;
      if (scrollHistory.value)
        scrollHistory.value?.scrollToTop();
    }
  },
  { immediate: true }
);
</script>

<style lang="sass" scoped>
.step_body
  padding: 0px 15px
.loading-container
  display: flex
  width: 100%
  align-items: center
</style>
